import { MenuButton } from '@mui/base';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Box, IconButton, List, Paper, styled } from "@mui/material";
import { ReactNode } from "react";
import { canEdit } from "../../utils/permissions";
import SegmentedSwitch from "../switch/SegmentedSwitch";
import DownloadMenu from "./DownloadMenu";

const Listbox = styled(List)(({ theme }) => ({
    fontFamily: ['IBM Plex Sans', 'sans-serif'],
    fontSize: '0.875rem',
    boxSizing: 'border-box',
    padding: '6px',
    margin: '12px 0',
    minWidth: '50px',
    borderRadius: '12px',
    overflow: 'auto',
    outline: '0px',
    background: theme.palette.mode === 'dark' ? '#1C2025' : '#fff',
    border: `1px solid ${theme.palette.mode === 'dark' ? '#434D5B' : '#DAE2ED'}`,
    color: theme.palette.mode === 'dark' ? '#C7D0DD' : '#1C2025',
    boxShadow: `0px 4px 6px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.50)' : 'rgba(0,0,0, 0.05)'}`,
    zIndex: 9999,
}));

const NoStyleMenuButton = styled(MenuButton)(() => ({
    background: 'none',
    border: 'none',
}));

interface ToolbarProps {
    onFilterClick?: () => void;
    onCreate?: () => void;
    isFilterActive?: boolean;
    downloadButtons?: DownloadButton[];
    segmentedSwitchProps?: {
        selected: "left" | "right";
        onChange: (value: "left" | "right") => void;
        leftIcon: ReactNode;
        leftLabel: string;
        rightIcon: ReactNode;
        rightLabel: string;
        tooltipText: string;
    };
}


interface DownloadButton {
    label: string;
    onClick: () => void;
}

const Toolbar = ({ onCreate, onFilterClick, isFilterActive, downloadButtons, segmentedSwitchProps }: ToolbarProps) => {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            component={Paper}
            sx={{ width: "100%", padding: 1, marginBottom: 1, paddingX: 2, zIndex: 9999 }}
        >
            <Box display="flex" alignItems="center">
                {onFilterClick && (
                    <IconButton onClick={onFilterClick} sx={{ color: (theme) => isFilterActive ? theme.palette.primary.main : theme.palette.primary.dark }}>
                        {isFilterActive ? <FilterAltIcon /> : <FilterAltOffIcon />}
                    </IconButton>
                )}
            </Box>

            <Box>
                {segmentedSwitchProps && (
                    <SegmentedSwitch
                        selected={segmentedSwitchProps.selected}
                        onChange={segmentedSwitchProps.onChange}
                        leftIcon={segmentedSwitchProps.leftIcon}
                        rightIcon={segmentedSwitchProps.rightIcon}
                        leftLabel={segmentedSwitchProps.leftLabel}
                        rightLabel={segmentedSwitchProps.rightLabel}
                        tooltipText={segmentedSwitchProps.tooltipText}
                    />
                )}
            </Box>

            <Box>
                {onCreate && canEdit() && (
                    <IconButton onClick={onCreate} sx={{ color: (theme) => theme.palette.primary.dark }}>
                        <AddCircleOutlineIcon></AddCircleOutlineIcon>
                    </IconButton>
                )}

                {downloadButtons && (
                    <DownloadMenu buttons={downloadButtons} iconSize="medium" />
                )}

            </Box>

        </Box>
    );
};

export default Toolbar;